import { ROLES } from "../utils/acl";

export const MENU_MEMBER = [
  {
    section: "My Area",
    items: [
      {
        label: "My Dashboard",
        icon: "bi-person-circle",
        to: "/me",
        roles: [ROLES.MEMBER, ROLES.TREASURER, ROLES.ADMIN],
      },
      {
        label: "My Statement",
        icon: "bi-file-earmark-text",
        to: "/me/statement",
        roles: [ROLES.MEMBER, ROLES.TREASURER, ROLES.ADMIN],
      },
      {
        label: "My Contributions",
        icon: "bi-cash-coin",
        to: "/me/contributions",
        roles: [ROLES.MEMBER, ROLES.TREASURER, ROLES.ADMIN],
      },
      {
        label: "My Loans",
        icon: "bi-bank",
        roles: [ROLES.MEMBER, ROLES.TREASURER, ROLES.ADMIN],
        children: [
          { label: "My Loans", icon: "bi-bank", to: "/me/loans" },
          {
            label: "Loans Application",
            icon: "bi-bank",
            to: "/me/my-loan-applications",
          },
        ],
      },
      {
        label: "My Penalties",
        icon: "bi-exclamation-triangle",
        to: "/me/penalties",
        roles: [ROLES.MEMBER, ROLES.TREASURER, ROLES.ADMIN],
      },
      {
        label: "My Withdrawals",
        icon: "bi-wallet2",
        to: "/me/withdrawals",
        roles: [ROLES.MEMBER, ROLES.TREASURER, ROLES.ADMIN],
      },
    ],
  },
];

export const MENU_ADMIN = [
  {
    section: "Administration",
    roles: [ROLES.ADMIN, ROLES.TREASURER],
    items: [
      {
        label: "Admin Overview",
        icon: "bi-speedometer2",
        to: "/admin",
        roles: [ROLES.ADMIN, ROLES.TREASURER],
      },

      {
        label: "Members",
        icon: "bi-people",
        to: "/admin/members",
        roles: [ROLES.ADMIN, ROLES.TREASURER],
      },

      {
        label: "Finance",
        icon: "bi-wallet2",
        roles: [ROLES.ADMIN, ROLES.TREASURER],
        children: [
          {
            label: "Statement",
            icon: "bi-file-earmark-text",
            to: "/admin/statement",
          },
          {
            label: "Contributions",
            icon: "bi-cash-coin",
            to: "/admin/contributions",
          },
          {
            label: "Payroll Contributions",
            icon: "bi-calendar-check",
            to: "/admin/payroll-batches",
          },
          {
            label: "Expenses",
            icon: "bi-receipt",
            to: "/admin/expenses",
          },
          {
            label: "Penalties",
            icon: "bi-exclamation-triangle",
            to: "/admin/penalties",
          },
          {
            label: "Withdrawals",
            icon: "bi-cash-stack",
            to: "/admin/withdrawals",
          },
          {
            label: "Profit Cycle",
            icon: "bi-clock",
            to: "/admin/profit-cycle",
          },
          {
            label: "Reconciliation",
            icon: "bi-clipboard-check",
            to: "/admin/reconciliation",
          },
          {
            label: "Matrix Report",
            icon: "bi-table",
            to: "/admin/reports/monthly-matrix",
          }
        ],
      },

      {
        label: "Loans",
        icon: "bi-bank",
        roles: [ROLES.ADMIN, ROLES.TREASURER],
        children: [
          {
            label: "All Loans",
            icon: "bi-list",
            to: "/admin/loans",
          },
          {
            label: "Repayment Sheet",
            icon: "bi-table",
            to: "/admin/loans/repayment-sheet",
          },
          {
            label: "Bulk Loan Migration",
            icon: "bi-upload",
            to: "/admin/loans/import",
          },
          {
            label: "Loan Applications Review",
            icon: "bi-clipboard-check",
            to: "/admin/loan-applications-review",
          },
        ],
      },

      {
        label: "Commitments",
        icon: "bi-check2-circle",
        to: "/admin/commitments",
        roles: [ROLES.ADMIN, ROLES.TREASURER],
      },

      {
        label: "Settings",
        icon: "bi-gear",
        to: "/admin/settings/financial-years",
        roles: [ROLES.ADMIN, ROLES.TREASURER],
      },
    ],
  },
];
